import { ApiMap } from '../ApiMap';
import { createApiCache } from './createApiCache';
import { getFetchUsers } from './User';
import { ContentTypes } from '../constants/Content';
const ContentCache = {};
const MeetingCache = {};
export function getFetchContentPageList(http) {
  const withContentCache = createApiCache(http.get, ApiMap.PAGES_SEARCH.getUrl, ContentCache);
  return function fetchContentPageList(params) {
    const httpParams = {
      query: Object.assign({
        type: ContentTypes,
        restrictByPermissions: true
      }, params)
    };
    return withContentCache('', httpParams);
  };
}
export function getFetchPageBySlug(http) {
  return function fetchPageBySlug(slug, domain) {
    const fetchContentPageList = getFetchContentPageList(http);
    let domainParams = {};
    if (domain) {
      domainParams = {
        redirectDomain: domain,
        domain
      };
    }
    const params = Object.assign({
      path: decodeURIComponent(slug),
      offset: 0
    }, domainParams);
    return fetchContentPageList(params);
  };
}
export function getFetchMeetingList(http) {
  const withMeetingCache = createApiCache(http.get, ApiMap.MEETINGS.getUrl, MeetingCache);
  return function fetchMeetingList() {
    return withMeetingCache();
  };
}
export function getFetchMeetingBySlug(http) {
  const withMeetingCache = createApiCache(http.get, ApiMap.MEETINGS_SEARCH.getUrl, MeetingCache);
  return function fetchMeetingBySlug(slug) {
    const uriEncodedSlug = encodeURIComponent(slug);
    return withMeetingCache(uriEncodedSlug);
  };
}
export function getFetchMeetingsByUsers(http) {
  const fetchUsers = getFetchUsers(http);
  const fetchMeetingList = getFetchMeetingList(http);
  return function fetchMeetingsByUsers() {
    return Promise.all([fetchUsers(), fetchMeetingList()]).then(([users, {
      results: meetings
    }]) => {
      return users.reduce((meetingsByUser, user) => {
        const userMeetings = meetings.filter(meeting => meeting.userId === user.id);
        if (userMeetings.length) {
          return [...meetingsByUser, Object.assign({}, user, {
            meetings: userMeetings
          })];
        }
        return meetingsByUser;
      }, []);
    });
  };
}